<div class="signin-content">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Login</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="login()">
        <p>Please login to continue</p>
        <mat-form-field class="full-width-input">
          <input matInput placeholder="User" formControlName="username">
          <mat-error *ngIf="isFieldInvalid('username')">
            Please inform your user name
          </mat-error>
        </mat-form-field>
        <mat-form-field class="full-width-input">
          <input matInput type="password" placeholder="Password" formControlName="password">
          <mat-error *ngIf="isFieldInvalid('password')">
            Please inform your password
          </mat-error>
        </mat-form-field>
        <mat-dialog-actions>
          <button mat-flat-button type="button" (click)="clear()">Clear</button>
          <button mat-flat-button color="primary" type="submit">Login</button>
        </mat-dialog-actions>
      </form>
    </mat-card-content>
  </mat-card>
</div>